/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

import "./style.css";
import plantillaTarifas from "../../../../../assets/Docs/average_rates_template.xlsx";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";

function AddTarifas({ handleClick }) {
  const [file, setFile] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleFormData = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFormSubmit = async (data) => {
    const user = localStorage.getItem("user");
    const user_id = JSON.parse(user).id;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/average_rates/uploadFile/${user_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire("Creado!", "El registro ha sido creado.", "success");
        handleClick("Tarifas");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error!", error.response.data.message, "error");
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className="rootwizard" id="rootwizard">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <button className="nav-link active" data-toggle="tab">
              General
            </button>
          </li>
        </ul>
        <br />
        <div className="tab-content">
          <div className="tab-pane fade show active" id="tab1">
            <form
              enctype="multipart/form-data"
              onSubmit={handleSubmit(handleFormSubmit)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <div className="row mt-3">
                <div className="form-group col-12 mb-4">
                  <a href={plantillaTarifas} download>
                    <button type="button" className="btn btn-primary">
                      Descargar template
                    </button>
                  </a>
                </div>
                <div className="form-group col-12 mb-4">
                  <label htmlFor="file">Archivo de tarifas</label>

                  <input
                    type="file"
                    className={`form-control ${
                      errors.file ? "missing-field" : ""
                    }`}
                    id="file"
                    name="file"
                    data-fv-field="file"
                    {...register("file", {
                      required: "El campo es requerido",
                      validate: {
                        validate: (value) => {
                          const file = value[0];
                          var allowedExtensions = /(.xlsx)$/i;
                          if (!allowedExtensions.exec(file.name)) {
                            return false;
                          }
                          return true;
                        },
                      },
                    })}
                    onChange={handleFormData}
                  />

                  {errors.file?.type === "required" && (
                    <small
                      className="help-block"
                      data-fv-validator="notEmpty"
                      data-fv-for="file"
                      data-fv-result="INVALID"
                    >
                      El campo es requerido
                    </small>
                  )}
                  {errors.file?.type === "validate" && (
                    <small
                      className="help-block"
                      data-fv-validator="notEmpty"
                      data-fv-for="file"
                      data-fv-result="INVALID"
                    >
                      El archivo debe ser .xlsx
                    </small>
                  )}
                </div>
              </div>
              <nav>
                <ul className="pagination pager wizard">
                  <li className="page-item previous disabled">
                    <a href="#" className="page-link">
                      Anterior
                    </a>
                  </li>
                  <li
                    className="page-item next ms-auto disabled hidden"
                    style={{ display: "none" }}
                  >
                    <a href="#" className="page-link">
                      Siguiente
                    </a>
                  </li>
                  <li className="page-item next finish ms-auto">
                    <button type="submit" className="page-link">
                      Finalizar
                    </button>
                  </li>
                </ul>
              </nav>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTarifas;
